<template>
    <div class="card-content has-text-centered">
        <div class="is-flex is-align-items-top is-justify-content-center">
            <p
                class="heading has-text-white has-text-weight-semibold mb-0 is-size-6 mr-2"
            >
                {{ header }}
            </p>
            <div v-tooltip="'Actualiza los montos de la cuenta bancaria'">
                <div class="box-bell" rel="main">
                    <div class="bell-notification">
                        <span class="material-icons has-text-white">
                            add_circle
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <p
            class="has-text-weight-semibold is-size-3 is-money is-money-cardEntity has-text-white"
        >
            {{ amount | toMoney }}
        </p>

        <div class="is-flex is-flex-direction-column">
            <span class="has-text-weight-light mb-0 is-size-7 has-text-white">
                {{ message }}
            </span>
        </div>
    </div>
</template>

<script>
import { parseToMoney } from "@/utils/currency";
import moment from "moment";

export default {
    name: "CardTotalEntity",
    filters: {
        toMoney: (value) => {
            return parseToMoney(value);
        },
    },
    data() {
        return {
            today: moment(new Date()).format("YYYY-MM-DD"),
        };
    },
    methods: {
        moment(date) {
            moment.locale("es");
            return moment(date);
        },
    },
    props: {
        header: {
            type: String,
        },
        amount: {
            type: Number,
        },
        updated_at: {
            type: String,
        },
        // password_change: {
        //     type: Boolean,
        // },
    },
    computed: {
        message() {
            const notUpdatedInLastDay = this.updated_at < this.today;
            if (this.amount === 0) {
                return "Haz click aquí para agregar el monto";
            // } else if (this.password_change) {
            //     return "La clave de alguna de sus cuentas bancarias fue cambiada.";    
            } else if (this.updated_at) {
                if (notUpdatedInLastDay) {
                    return `Actualizado al ${this.moment(
                        this.updated_at
                    ).format("D [de] MMMM [del] YYYY")}`;
                } else {
                    return "Actualizado en la ultima hora";
                }
            } else {
                return "Los saldos pueden demorar hasta una hora en verse reflejados";
            }
        },
    },
};
</script>
